export default class Session{
    constructor(){

    };

    setPID(pid){
        sessionStorage.setItem('pid',pid);
    };
    getPID(){
       return sessionStorage.getItem('pid');
    };
    setKinoID(kino_id){
        sessionStorage.setItem('kino_id',kino_id);
    };
    getKinoID(){
        return sessionStorage.getItem('kino_id');
    };

    setEmail(email){
        localStorage.setItem('user_email',email);
    }

    getEmail(){
        return localStorage.getItem('user_email');
    }

    setResumeRecorder(resume=''){
        sessionStorage.setItem('resume_recorder',resume);
    };

    getResumeRecorder(){
        return sessionStorage.getItem('resume_recorder');
    };

    lock(){
        sessionStorage.setItem('_locked','1');
    };
    unlock(){
        sessionStorage.removeItem('_locked');
    };
    isLocked(){
        return sessionStorage.getItem('_locked')
    }
    clear(){
        sessionStorage.clear(); 
    }
}